define(function(require) {
    const i18n = require('i18n');
    const Form = require('class/form.class');
    const userValidationConfig = require('modules/user/user.validation.config');
    const LimitsView = require('portlets/responsible-gaming/limits/limits.view');

    return LimitsView.extend({

        render: function() {
            this.$el.html(this.tmpl('limits', this.model.toJSON()));

            var $formSessionTimer = this.$('.fn-form-session-timer');
            if ($formSessionTimer.length) {
                this.formSessionTimer = new Form($formSessionTimer);
            }

            var $formDepositLimits = this.$('.fn-deposit-limits');
            if ($formDepositLimits.length) {
                this.formDepositLimits = new Form($formDepositLimits, {
                    validationConfig: userValidationConfig(),
                    data: this.getFormData()
                });
            }

            var $formLossLimits = this.$('.fn-loss-limits');
            if ($formLossLimits.length) {
                var model = this.model.toJSON();
                var dayLossLimit = this.$('.fn-loss-limits #daylosslimit');
                var weekLossLimit = this.$('.fn-loss-limits #weeklosslimit');
                var monthLossLimit = this.$('.fn-loss-limits #monthlosslimit');

                if(!model.dailyremaininglosslimitdate && !this.options.updateFromPopup) {
                    dayLossLimit[0].selectedIndex = 0;
                }

                if(!model.weeklyremaininglosslimitdate && !this.options.updateFromPopup) {
                    weekLossLimit[0].selectedIndex = 0;
                }

                if(!model.monthlyremaininglosslimitdate && !this.options.updateFromPopup) {
                    monthLossLimit[0].selectedIndex = 0;
                }
                for(var k = 0; k < 3; k++) {
                    if($formLossLimits[0][k][0]?.value && $formLossLimits[0][k][0].value === '0') {
                        $formLossLimits[0][k][0].text = i18n.t('playtech.mobile.ngresponsiblegaming.limits.notdefined');
                    }
                }
                this.formLossLimits = new Form($formLossLimits, {
                    validationConfig: this._getValidationConfig()
                });
            }

            var $formBetLimits = this.$('.fn-bet-limits');
            if ($formBetLimits.length) {
                this.formBetLimits = new Form($formBetLimits, {
                    validationConfig: this._getValidationConfig()
                });
            }

            this.validateAllLimitsAscendingOrder();

            return this;
        },

    });
});
